import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { FormlyFieldAnyComponent } from '@app/shared/components/formly-components/formly-field-any/formly-field-any.component';
import { TranslationFieldEditorComponent } from '@app/shared/components/translation-field-editor/translation-field-editor.component';

@Component({
  selector: 'app-formly-field-translation',
  templateUrl: './formly-field-translation.component.html',
  styleUrls: ['./formly-field-translation.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslationFieldEditorComponent,
  ],
})
export class FormlyFieldTranslationComponent extends FormlyFieldAnyComponent {
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  constructor() {
    super();
  }

  public get isReadonly(): boolean {
    return Boolean(this.options.formState?.disabled || this.field.props?.disabled || this.field.props?.readonly);
  }

  public get translationValue(): Record<string, string> {
    const value = this.formControl?.value;
    if (!value || typeof value !== 'object' || Array.isArray(value)) {
      return {};
    }
    return value as Record<string, string>;
  }

  public get multiLine(): boolean {
    const props = this.field.props as { multiLine?: boolean } | undefined;
    return props?.multiLine !== false;
  }

  public writeTranslations(nextValue: Record<string, string>): void {
    this.formControl.setValue(nextValue);
    this.formControl.markAsDirty();
    this.formControl.markAsTouched();
    this.onChange(nextValue);
    this.changeDetectorRef.markForCheck();
  }
}
